import { friendlyNameMaps } from '@/components/form/input/StatusMapper'
import { getStatusColor } from '@/features/products/utils'
import { cn } from '@/lib/utils'

interface Props {
  status: string
}

export default function ClientStatusTag({ status }: Props) {
  return (
    <div className={cn('text-center rounded-full px-2 py-1 text-white', getStatusColor(status))}>
      {friendlyNameMaps['clientStatus'][status] || '-'}
    </div>
  )
}
